import React from "react";
import { useState, useEffect } from "react";
import "./AdminBooking.css";

const BusLayout = ({
  bookedSeat,
  layout,
  adminSelectSeat,
  setAdminSelectSeat,
  setAvailableSeat,
  availableSeat
}) => {
  

  const seatFilter = () => {
    const seatStatusChange = layout?.map((each) => {
      if (bookedSeat.includes(each._id)) {
        return { ...each, status: "booked" };
      }
      return each;
    });

    const seatsByRow = seatStatusChange.reduce((acc, seat) => {
      const row = seat.row;

      if (!acc[row]) {
        acc[row] = [];
      }

      acc[row].push({
        status: seat.status,
        number: seat.number,
        seatId: seat._id,
      });

      return acc;
    }, {});

    setAvailableSeat(Object.values(seatsByRow));
  };

  // console.log(availableSeat);

  const adminSeatSelectFn = (e, selectSeat) => {
    console.log(selectSeat);

    let seatId = e.target.value;

    if (e.target.checked) {
      setAdminSelectSeat((prev) => [...prev, selectSeat]);
    } else {
      const resultArr = adminSelectSeat.filter((each) => each.seatId != seatId);
      setAdminSelectSeat(resultArr);
    }
  };

  console.log(adminSelectSeat);

  useEffect(() => {
    seatFilter();
  }, [layout, bookedSeat]);

  return (
    <>
      {availableSeat.length > 0 && (
        <div className="bus-layout">
          {availableSeat?.map((row, index) => (
            <div
              className={`seat-row ${index === availableSeat.length - 1 ? "last-row" : ""}`}
              key={index}
            >
              <div className={`seat ${row[0]?.status}`}>
                <input
                  type="checkbox"
                  name="vehicle3"
                  value={row[0]?.seatId}
                  disabled={row[0]?.status === "booked"}
                  onChange={(e) =>
                    adminSeatSelectFn(e, {
                      seatId: row[0]?.seatId,
                      seatNumber: row[0]?.number,
                    })
                  }
                ></input>
                <span>{row[0]?.number}</span>
              </div>
              <div className={`seat ${row[1]?.status}`}>
                <input
                  type="checkbox"
                  name="vehicle3"
                  value={row[1]?.seatId}
                  disabled={row[1]?.status === "booked"}
                  onChange={(e) =>
                    adminSeatSelectFn(e, {
                      seatId: row[1]?.seatId,
                      seatNumber: row[1]?.number,
                    })
                  }
                ></input>
                <span>{row[1]?.number}</span>
              </div>

              <div className="aisle"></div>

              <div className={`seat ${row[2]?.status}`}>
                <input
                  type="checkbox"
                  name="vehicle3"
                  value={row[2]?.seatId}
                  disabled={row[2]?.status === "booked"}
                  onChange={(e) =>
                    adminSeatSelectFn(e, {
                      seatId: row[2]?.seatId,
                      seatNumber: row[2]?.number,
                    })
                  }
                ></input>
                <span>{row[2]?.number}</span>
              </div>
              <div className={`seat ${row[3]?.status}`}>
                <input
                  type="checkbox"
                  name="vehicle3"
                  value={row[3]?.seatId}
                  disabled={row[3]?.status === "booked"}
                  onChange={(e) =>
                    adminSeatSelectFn(e, {
                      seatId: row[3]?.seatId,
                      seatNumber: row[3]?.number,
                    })
                  }
                ></input>
                <span>{row[3]?.number}</span>
              </div>

              {index === 9 && (
                <div className={`seat ${row[4]?.status}`}>
                  <input
                    type="checkbox"
                    name="vehicle3"
                    value={row[4]?.seatId}
                    disabled={row[4]?.status === "booked"}
                    onChange={(e) =>
                      adminSeatSelectFn(e, {
                        seatId: row[4]?.seatId,
                        seatNumber: row[4]?.number,
                      })
                    }
                  ></input>
                  <span>{row[4]?.number}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default BusLayout;
